(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  const footerBlocks = Array.from(document.querySelectorAll('.footer-block'));
  const breakpoint = 1023;
  let isMobile = window.innerWidth <= breakpoint;

  // To keep track of listeners so we can remove them on desktop
  const listenersMap = new Map();

  // Track if first dropdown was manually closed
  let firstDropdownManuallyClosed = false;

  function openDropdown(block) {
    block.classList.add('open');
  }

  function closeDropdown(block) {
    block.classList.remove('open');
  }

  function toggleDropdown(block) {
    block.classList.toggle('open');
  }

  function setupMobileBehavior() {
    footerBlocks.forEach((block, index) => {
      const heading = block.querySelector('.footer-block__heading');
      if (!heading) return;

      // Remove any existing listener first (avoid duplicates)
      if (listenersMap.has(block)) {
        heading.removeEventListener('click', listenersMap.get(block));
      }

      const clickHandler = () => {
        toggleDropdown(block);
        if (index === 0 && !block.classList.contains('open')) {
          firstDropdownManuallyClosed = true;
        }
        if (index === 0 && block.classList.contains('open')) {
          firstDropdownManuallyClosed = false;
        }
      };

      heading.addEventListener('click', clickHandler);
      listenersMap.set(block, clickHandler);
    });

    // Open first dropdown by default if not manually closed
    if (!firstDropdownManuallyClosed) {
      openDropdown(footerBlocks[0]);
    }
    // Close others by default
    footerBlocks.slice(1).forEach(block => closeDropdown(block));
  }

  function setupDesktopBehavior() {
    footerBlocks.forEach(block => {
      const heading = block.querySelector('.footer-block__heading');
      if (!heading) return;

      // Remove click listener if any
      if (listenersMap.has(block)) {
        heading.removeEventListener('click', listenersMap.get(block));
        listenersMap.delete(block);
      }

      // Make all open on desktop
      openDropdown(block);
    });

    // Reset manual close flag on desktop
    firstDropdownManuallyClosed = false;
  }

  function onResize() {
    const currentlyMobile = window.innerWidth <= breakpoint;
    if (currentlyMobile && !isMobile) {
      // switched to mobile
      setupMobileBehavior();
    } else if (!currentlyMobile && isMobile) {
      // switched to desktop
      setupDesktopBehavior();
    }
    isMobile = currentlyMobile;
  }

  window.addEventListener('resize', onResize);
  document.addEventListener('DOMContentLoaded', () => {
    if (isMobile) {
      setupMobileBehavior();
    } else {
      setupDesktopBehavior();
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      document.querySelector('.for-sticky')?.classList.add('header-pdp-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.querySelector('.for-sticky')?.classList.add('header-pdp-sticky');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.querySelector('.for-sticky')?.classList.remove('header-pdp-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if(this.searchModal) {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);



function hideHovwer() {

(function () {
  const menus = Array.from(document.querySelectorAll('.mega-menu'));
  const handlersMap = new WeakMap();
  let openMenu = null;
  let globalHandlersAdded = false;
  const desktopMQ = window.matchMedia('(min-width:1024px)');
  const menuBg = document.querySelector('.menu-dropdown-bg');

  function init() {
    if (desktopMQ.matches) {
      enableDesktopMenu();
    } else {
      disableDesktopMenu();
    }
  }

  function enableDesktopMenu() {
    if (!globalHandlersAdded) {
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onDocumentKeydown);
      globalHandlersAdded = true;
    }

    menus.forEach(menu => {
      
      const trigger = menu.querySelector('.list-menu__item');
      const content = menu.querySelector('.mega-menu__content');
      if (!trigger || !content || content.children.length === 0) return;
      if (handlersMap.has(menu)) return;

      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      menu.classList.remove('open');


      function onTriggerClick(e) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button === 1) return;
        const isOpen = menu.classList.contains('open');
        if (!isOpen) {
          e.preventDefault(); // stop navigation first time
          toggleMenu(menu);
        }
      }

      function onTriggerKeydown(e) {
        if (e.key === ' ' || e.code === 'Space' || e.key === 'Spacebar') {
          e.preventDefault();
          toggleMenu(menu);
        }
        if (e.key === 'Enter') {
          // Redirect to the link's href
          e.preventDefault();
          window.location.href = trigger.getAttribute('href');
        }
        if (e.key === 'Escape' || e.key === 'Esc' || e.key === 'Backspace') {
          closeMenu(menu);
          trigger.focus();
        }
      }

      // Hover events
      function onMouseEnter() {
        if (desktopMQ.matches) {
          if (openMenu && openMenu !== menu) {
            closeMenu(openMenu);
          }
          openMenuFn(menu);
        }
      }
      function onMouseLeave() {
        if (desktopMQ.matches) {
          closeMenu(menu);
        }
      }

      function onMenuFocusOut() {
        setTimeout(() => {
          if (!menu.contains(document.activeElement)) {
            closeMenu(menu);
          }
        }, 10);
      }

      trigger.addEventListener('click', onTriggerClick);
      trigger.addEventListener('keydown', onTriggerKeydown);
      menu.addEventListener('focusout', onMenuFocusOut);

      // Add hover listeners
      menu.addEventListener('mouseenter', onMouseEnter);
      menu.addEventListener('mouseleave', onMouseLeave);

      handlersMap.set(menu, { onTriggerClick, onTriggerKeydown, onMenuFocusOut, onMouseEnter, onMouseLeave });
    });
  }

  function disableDesktopMenu() {
    menus.forEach(menu => {
      const handlers = handlersMap.get(menu);
      if (!handlers) return;
      const trigger = menu.querySelector('.list-menu__item');

      trigger.removeEventListener('click', handlers.onTriggerClick);
      trigger.removeEventListener('keydown', handlers.onTriggerKeydown);
      menu.removeEventListener('focusout', handlers.onMenuFocusOut);
      menu.removeEventListener('mouseenter', handlers.onMouseEnter);
      menu.removeEventListener('mouseleave', handlers.onMouseLeave);

      trigger.setAttribute('aria-expanded', 'false');
      menu.classList.remove('open');
      handlersMap.delete(menu);
    });

    if (globalHandlersAdded) {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onDocumentKeydown);
      globalHandlersAdded = false;
    }

    openMenu = null;
  }

  function onDocumentClick(e) {
    if (openMenu && !openMenu.contains(e.target)) {
      closeMenu(openMenu);
    }
  }

  function onDocumentKeydown(e) {
    if (!openMenu) return;
    if (e.key === 'Escape' || e.key === 'Esc' || e.key === 'Backspace') {
      const trigger = openMenu.querySelector('.list-menu__item');
      closeMenu(openMenu);
      trigger && trigger.focus();
    }
  }

  function toggleMenu(menu) {
    if (openMenu && openMenu !== menu) {
      closeMenu(openMenu);
    }
    const trigger = menu.querySelector('.list-menu__item');
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeMenu(menu);
    } else {
      openMenuFn(menu);
    }
  }

  function openMenuFn(menu) {
    const trigger = menu.querySelector('.list-menu__item');
    trigger.setAttribute('aria-expanded', 'true');
    menu.classList.add('open');
    menu.querySelector('.mega-menu__content').setAttribute('aria-hidden', 'false');
    openMenu = menu;
     if (menuBg) menuBg.classList.add('menu-open');
  }

  function closeMenu(menu) {
    const trigger = menu.querySelector('.list-menu__item');
    trigger.setAttribute('aria-expanded', 'false');
    menu.classList.remove('open');
    menu.querySelector('.mega-menu__content').setAttribute('aria-hidden', 'true');
    if (openMenu === menu) openMenu = null;

    if (menuBg) menuBg.classList.remove('menu-open'); 
  }

  if (typeof desktopMQ.addEventListener === 'function') {
    desktopMQ.addEventListener('change', e => e.matches ? enableDesktopMenu() : disableDesktopMenu());
  } else if (typeof desktopMQ.addListener === 'function') {
    desktopMQ.addListener(e => e.matches ? enableDesktopMenu() : disableDesktopMenu());
  }

  document.addEventListener('DOMContentLoaded', init);
})();

}

// hideHovwer();



  } catch(e) { console.error(e); }
})();
})();
